import { z } from 'zod';
import { LogLevel } from '../../../types/logLevel';
import { SmscMode } from '../../../models/smscModel';

const positiveIntNumber = z.number().int().positive();

export const smscConnectionValidationSchema = z.object({
  host: z.string(),
  port: positiveIntNumber,
  mode: z.nativeEnum(SmscMode),
  systemType: z.string().nullish(),
  username: z.string().max(15),
  password: z.string().max(8),
  sourceAddrTon: positiveIntNumber,
  sourceAddrNpi: positiveIntNumber,
  destAddrTon: positiveIntNumber,
  destAddrNpi: positiveIntNumber,
  enquireLinkInterval: positiveIntNumber,
  instances: positiveIntNumber,
  throughput: positiveIntNumber,
  throughputMt: positiveIntNumber.nullish(),
  throughputMo: positiveIntNumber.nullish(),
});

export const smscFormValidationSchema = z.object({
  smscId: z.string(),
  logFile: z.string(),
  logLevel: z.nativeEnum(LogLevel),
  connections: z.array(smscConnectionValidationSchema).nonempty(),
});
